<template>
  <div>
  <main class="site-content">
    <section class="hero is-danger">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Character
          </h1>
          <h2 class="subtitle" style="margin-top: 0.5vh;">
            General Information
          </h2>
          <!-- Internet Explorer User may encounter some problems -->
          <div v-if="isIE" class="notification is-danger">
            <div class="has-text-centered">This site is not optimized for Internet Explorer and may not work like expected!</div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="content">
          <h1>General</h1>
          <p>
            Fullname: IceTiger<br/>
            Nickname: Icy<br/>
            <br/>
            Sex: Male<br/>
            Age: 24<br/>
            <br/>
            Species: siberian tiger<br/>
            Height: 1.75 meter<br/>
            Fur color: white with green stripes<br/>
            Eye color: green<br/>
            Hair color: red with a green tip<br/>
	    Hobbies: TBD<br/>
          </p>
        </div>
      </div>
    </section>
  </main>
  <vue-headful title="Character | IceTiger" description="About IceTiger" keywords="character, icetiger" url="https://icetiger.eu/character"></vue-headful>
  </div>
</template>
<script>
export default {
  name: 'Character',
  data: function() {
    return {
      isIE: /Trident\/|MSIE/.test(window.navigator.userAgent)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Character.vue